
(function () {
  function getMediaIdFromTrigger(trigger) {
    if (!trigger) return null;
    var btn = trigger.closest('[data-media-id]');
    if (btn) {
      var raw = btn.getAttribute('data-media-id');
      if (raw) return raw.indexOf('-') > -1 ? raw : null;
    }
    var item = trigger.closest('.product__media-item[data-media-id]');
    return item ? item.getAttribute('data-media-id') : null;
  }

  function setActiveModalMedia(mediaId) {
    if (!mediaId) return;

    var rawId = mediaId;
    var numericId = mediaId.split('-').pop();

    setTimeout(function () {
      document.querySelectorAll('.product-media-modal__content').forEach(function (content) {
        var items = content.children;
        Array.prototype.forEach.call(items, function (item) {
          var itemId = item.getAttribute('data-media-id') || item.id || '';
          var isMatch =
            itemId === rawId ||
            itemId === numericId ||
            itemId.endsWith('-' + numericId) ||
            item.querySelector('[data-media-id="' + rawId + '"], [data-media-id="' + numericId + '"]');

          item.classList.toggle('is-active', !!isMatch);
        });

        if (!content.querySelector('.is-active') && items[0]) {
          items[0].classList.add('is-active');
        }
      });
    }, 120);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.product__media-toggle, .product__media-icon, .product__modal-opener');
    if (!trigger) return;

    var mediaId = getMediaIdFromTrigger(trigger);
    if (mediaId) setActiveModalMedia(mediaId);
  }, true);

  document.addEventListener('shopify:section:load', function () {});
})();
